/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var NotificationType;
(function (NotificationType) {
    NotificationType["Push"] = "Push";
    NotificationType["Email"] = "Email";
    NotificationType["TextMessage"] = "TextMessage";
})(NotificationType || (NotificationType = {}));
export function NotificationTypeFromJSON(json) {
    return NotificationTypeFromJSONTyped(json, false);
}
export function NotificationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function NotificationTypeToJSON(value) {
    return value;
}
